"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThrottledEventsWorker = void 0;
var json_nd_1 = require("json-nd");
var util_1 = require("./util");
var defaults_1 = require("./defaults");
var ThrottledEventsWorker = /** @class */ (function () {
    function ThrottledEventsWorker(config, transport) {
        this.config = config;
        this.transport = transport;
        this.queue = [];
        this.cooldownTimer = null;
        // Timestamp (ms) until which the post-send cooldown window is active. A timer
        // is only armed while there are queued events waiting for this window; when the
        // queue drains empty we keep the timestamp but drop the timer, so an idle worker
        // never holds a pending timer (which would otherwise keep a Node process alive
        // for the full interval.
        this.cooldownUntil = 0;
        this.inFlight = null;
        this.config = __assign(__assign({}, defaults_1.CONFIG), config);
        this.logger = this.originalLogger();
    }
    ThrottledEventsWorker.prototype.configure = function (opts) {
        for (var k in opts) {
            this.config[k] = opts[k];
        }
    };
    ThrottledEventsWorker.prototype.log = function (payload) {
        this.queue.push(payload);
        if (this.inFlight) {
            return;
        }
        // Crossing the bulk threshold preempts any pending cooldown and dispatches now.
        if (this.queue.length >= this.bulkThreshold()) {
            this.clearCooldownTimer();
            this.processQueue();
            return;
        }
        // A timer is already counting down the cooldown window; the queued event
        // will be picked up when it fires.
        if (this.cooldownTimer) {
            return;
        }
        // We're inside a cooldown window but no timer is armed (the queue had drained
        // empty after the previous send). Arm one for the remaining time so this event
        // still respects the interval.
        var remaining = this.cooldownRemainingMs();
        if (remaining > 0) {
            this.scheduleCooldownTimer(remaining);
            return;
        }
        this.processQueue();
    };
    ThrottledEventsWorker.prototype.flushAsync = function () {
        var _this = this;
        var _a;
        this.logger.debug('[Honeybadger] Flushing events');
        this.clearCooldownTimer();
        var previous = (_a = this.inFlight) !== null && _a !== void 0 ? _a : Promise.resolve();
        var flush = previous.then(function () { return _this.drainAll(); });
        // Mark the flush as in-flight so a concurrent log() doesn't start an
        // overlapping processQueue() drain while we're draining here.
        this.inFlight = flush;
        var clear = function () {
            if (_this.inFlight === flush) {
                _this.inFlight = null;
            }
        };
        flush.then(clear, clear);
        return flush;
    };
    ThrottledEventsWorker.prototype.drainAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.queue.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.send()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ThrottledEventsWorker.prototype.processQueue = function () {
        var _this = this;
        if (this.queue.length === 0 || this.inFlight) {
            return;
        }
        var inFlight = this.send()
            .catch(function (error) {
            _this.logger.error('[Honeybadger] Error making HTTP request:', error);
        })
            .then(function () {
            // Only reset if we're still the current operation; a flushAsync() may
            // have taken ownership of inFlight while this send was resolving.
            if (_this.inFlight === inFlight) {
                _this.inFlight = null;
                _this.scheduleNextDispatch();
            }
        });
        this.inFlight = inFlight;
    };
    ThrottledEventsWorker.prototype.scheduleNextDispatch = function () {
        var intervalMs = this.dispatchIntervalMs();
        // Capture the cooldown deadline at dispatch time so a later config change to
        // the interval doesn't retroactively shorten a window already in progress.
        this.cooldownUntil = Date.now() + intervalMs;
        if (this.queue.length >= this.bulkThreshold()) {
            this.processQueue();
            return;
        }
        // Only arm a timer when there's queued work waiting for it. If the queue is
        // empty, `cooldownUntil` alone enforces the window: the next log() will arm a
        // timer for whatever time remains, and an idle worker holds no timer at all.
        if (this.queue.length > 0) {
            this.scheduleCooldownTimer(intervalMs);
        }
    };
    ThrottledEventsWorker.prototype.cooldownRemainingMs = function () {
        if (!this.cooldownUntil) {
            return 0;
        }
        return Math.max(0, this.cooldownUntil - Date.now());
    };
    ThrottledEventsWorker.prototype.scheduleCooldownTimer = function (ms) {
        var _this = this;
        this.cooldownTimer = setTimeout(function () {
            _this.cooldownTimer = null;
            _this.processQueue();
        }, ms);
        // In Node, don't let a pending cooldown timer keep the process alive for the
        // whole batching interval. `unref` lets the event loop go idle so the process
        // can exit (or a shutdown / `beforeExit` handler can run) promptly instead of
        // blocking for `dispatchIntervalSeconds`. Queued events aren't lost: a
        // `flushAsync()` on the way out still drains them before exit. (`unref` is
        // Node-only; the browser's numeric setTimeout handle has no such method.)
        if (typeof this.cooldownTimer === 'object' && this.cooldownTimer !== null && typeof this.cooldownTimer.unref === 'function') {
            this.cooldownTimer.unref();
        }
    };
    ThrottledEventsWorker.prototype.clearCooldownTimer = function () {
        if (this.cooldownTimer) {
            clearTimeout(this.cooldownTimer);
            this.cooldownTimer = null;
        }
    };
    ThrottledEventsWorker.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eventsData, data;
            return __generator(this, function (_a) {
                if (this.queue.length === 0) {
                    return [2 /*return*/];
                }
                eventsData = this.queue.splice(0, this.bulkThreshold());
                data = json_nd_1.NdJson.stringify(eventsData);
                return [2 /*return*/, this.makeHttpRequest(data)];
            });
        });
    };
    ThrottledEventsWorker.prototype.bulkThreshold = function () {
        var _a;
        var v = (_a = this.config.events) === null || _a === void 0 ? void 0 : _a.bulkThreshold;
        return typeof v === 'number' && v > 0 ? v : defaults_1.CONFIG.events.bulkThreshold;
    };
    ThrottledEventsWorker.prototype.dispatchIntervalMs = function () {
        var _a;
        var v = (_a = this.config.events) === null || _a === void 0 ? void 0 : _a.dispatchIntervalSeconds;
        var seconds = typeof v === 'number' && v >= 0 ? v : defaults_1.CONFIG.events.dispatchIntervalSeconds;
        return seconds * 1000;
    };
    ThrottledEventsWorker.prototype.makeHttpRequest = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.transport
                        .send({
                        headers: {
                            'X-API-Key': this.config.apiKey,
                            'Content-Type': 'application/json',
                        },
                        method: 'POST',
                        endpoint: (0, util_1.endpoint)(this.config.endpoint, '/v1/events'),
                        maxObjectDepth: this.config.maxObjectDepth,
                        logger: this.logger,
                    }, data)
                        .then(function (resp) {
                        if ([200, 201].includes(resp.statusCode)) {
                            _this.logger.debug('[Honeybadger] Events sent successfully');
                        }
                        else {
                            _this.logger.debug("[Honeybadger] Events failed[".concat(resp.statusCode, "]: ").concat(resp.body));
                        }
                    })
                        .catch(function (err) {
                        _this.logger.error("[Honeybadger] Error sending events: ".concat(err.message));
                    })];
            });
        });
    };
    /**
     * todo: improve this
     *
     * The events plugin overrides the console methods to enable automatic instrumentation
     * of console logs to the Honeybadger API.
     * So if we want to log something in here we need to use the original methods.
     */
    ThrottledEventsWorker.prototype.originalLogger = function () {
        var _this = this;
        var _a, _b, _c, _d;
        return {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            log: (_a = console.log.__hb_original) !== null && _a !== void 0 ? _a : console.log,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            info: (_b = console.info.__hb_original) !== null && _b !== void 0 ? _b : console.info,
            debug: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (!_this.config.debug) {
                    return;
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var func = (_a = console.debug.__hb_original) !== null && _a !== void 0 ? _a : console.debug;
                return func.apply(void 0, args);
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            warn: (_c = console.warn.__hb_original) !== null && _c !== void 0 ? _c : console.warn,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error: (_d = console.error.__hb_original) !== null && _d !== void 0 ? _d : console.error,
        };
    };
    return ThrottledEventsWorker;
}());
exports.ThrottledEventsWorker = ThrottledEventsWorker;
//# sourceMappingURL=throttled_events_worker.js.map